// @module WB.CategoriesOnSMTExt.CategoriesOnSMT
define('WB.CategoriesOnSMTExt.CategoriesOnSMT.View'
,	[
		'wb_categoriesonsmtext_categoriesonsmt.tpl'
	,	'Utils'
	,	'Categories.Utils'
	,	'SC.Configuration'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	,	'GlobalViews.Breadcrumb.View'
	,	'CMSadapter.Landing.View'
	]
,	function (
		wb_categoriesonsmtext_categoriesonsmt_tpl
	,	Utils
	,	CategoriesUtils
	,	Configuration
	,	Backbone
	,	jQuery
	,	_
	,	GlobalViewsBreadcrumbView
	,	CMSadapterLandingView
	)
{
	'use strict';
	
	_.extend(CMSadapterLandingView.prototype, {
		getBreadcrumbPages: function getBreadcrumbPages()
	 { 
	 	
	 
	 	var url = this.model.get('urlPath') || this.model.get('url')
		,	path = url[0] === '/' ? url : '/' + url;
		
		var currentPageBread = [];
		
		
		var customRecordData = this.model.get('fields')
		
		if(customRecordData)
		{
			if(customRecordData.custrecord_parent_one_name && customRecordData.custrecord_parent_one_name !== "")
			{
				currentPageBread.push({ href: customRecordData.custrecord_parent_one_link, text: customRecordData.custrecord_parent_one_name});
			}
			
			if(customRecordData.custrecord_parent_two_name && customRecordData.custrecord_parent_two_name !== "")
			{
				currentPageBread.push({ href: customRecordData.custrecord_parent_two_link, text: customRecordData.custrecord_parent_two_name});
			}
			
			if(customRecordData.custrecord_parent_three_name && customRecordData.custrecord_parent_three_name !== "")
			{
				currentPageBread.push({ href: customRecordData.custrecord_parent_three_link, text: customRecordData.custrecord_parent_three_name});
			}
			if(customRecordData.custrecord_parent_four_name && customRecordData.custrecord_parent_four_name !== "")
			{
				currentPageBread.push({ href: customRecordData.custrecord_parent_four_link, text: customRecordData.custrecord_parent_four_name});
			}
	 	}
		
		currentPageBread.push({ href: path, text: this.model.get('page_title')});
		return currentPageBread;
	 }
	 
	});
	// @class WB.CategoriesOnSMTExt.CategoriesOnSMT.View @extends Backbone.View
	return Backbone.View.extend({

		template: wb_categoriesonsmtext_categoriesonsmt_tpl


	,	initialize: function (options) {

			this.categories =  Configuration.get('navigationData') || [];
			var url = Backbone.history.fragment.split('?')[0];
			
			this.categoryUrl = url[0] === '/' ? url : '/' + url;
			this.breadcrumb = options.container._layoutInstance.breadcrumbPages || [];

			this.on('afterViewRender', this.renderCategories, this);
			
		}
	,	events: {
			'click [data-action="see-more"]': 'toggleSeeMoreLess'
		}

	,	bindings: {
		}

	, 	childViews: {
		
		}
	,	renderCategories: function ()
		{
			this.$('[data-collapsed="true"]').hide();
		}
		
	,	toggleSeeMoreLess: function(event)
		{
			var target = this.$(event.currentTarget)
			,	target_see_more = target.find('[data-type="see-more"]')
			,	target_see_less = target.find('[data-type="see-less"]')
			,	target_was_expanded = !!target.data('collapsed');

			if (target_was_expanded)
			{
				target_see_more.show();
				target_see_less.hide();
			}
			else
			{
				target_see_more.hide();
				target_see_less.show();
			}

			target.data('collapsed', !target_was_expanded);
		}

	,	checkBreadcrumb: function(name)
		{
			var breadcrumb = this.breadcrumb
			for(var i=0;i<breadcrumb.length; i++)
				{
					if(breadcrumb[i].text == name)
						{
							return true;
							break;
						}
				}
				
				return false	
		
		}	
	,	mapIt: function(filtered) {	
			var result = []
			var count = 1;
			  for(var i = 0;i<filtered.length;i++){
			//check if menu is from commerce category
			if(filtered[i]['data-type'] && filtered[i]['data-type'] === 'commercecategory')
                {
				var obj = {};
				if(filtered[i]['text']){
				  
					  obj['href'] = filtered[i]['href'] || '';
					  obj['data'] = filtered[i]['data'] ?  filtered[i]['data']:  {"hashtag": filtered[i]['data-hashtag'], 'touchpoint': filtered[i]['data-touchpoint']};
					  obj['text'] = filtered[i]['text'];
					  obj['data-type'] = filtered[i]['data-type'] || '';
					  obj['class'] = filtered[i]['class'];
					  obj['isActive'] = filtered[i]['href'] === this.categoryUrl;
					  obj['aditionalField'] = count;
					  obj['childExist'] = filtered[i]['categories'].length ? true : false;
					  obj['nonCollapsed'] = this.checkBreadcrumb(filtered[i]['text'])
					  
					  if(filtered[i]['isPartPage'] === 'T')
					{	
						var urlWithoutParent = filtered[i]['href'].substring(filtered[i]['href'].lastIndexOf('/'), filtered[i]['href'].length);
						obj['href'] = urlWithoutParent || ''; 
						obj['data'].hashtag = '#'+urlWithoutParent || '#';
					}
					
					
					
					
				}else{
				  obj['text'] = '';
				}
				if(filtered[i]['categories']){
				  obj['categories'] = this.mapIt(filtered[i]['categories']);
				}else{
				  obj['categories'] = [];
				}
				
				count++;
				result.push(obj);
				}
				
			  }
			  return result;
		}
		//@method getContext @return WB.CategoriesOnSMTExt.CategoriesOnSMT.View.Context
	,	getContext: function getContext()
		{
			//@class WB.CategoriesOnSMTExt.CategoriesOnSMT.View.Context
			var showFacet = this.categories.length
			,	values = []
			,	uncollapsible = Configuration.get('categories.sideMenu.uncollapsible')
			,	collapsed = Configuration.get('categories.sideMenu.collapsed');
    
			var navigationData = this.mapIt(this.categories) || []
		
			return {
					//@property {String} htmlId
				htmlId: _.uniqueId('commercecategory_')
                // @property {String} facetId
            ,	facetId: 'commercecategory'
                // @property {Boolean} showFacet
            ,	showFacet: !!showFacet
				//@property {Boolean} isUncollapsible
			,	isUncollapsible: !!uncollapsible
				//@property {Boolean} isCollapsed
			,	isCollapsed: !uncollapsible && collapsed
				//@property {Array<Object>} values
			,	categories: navigationData
           
			};
		}
	});
});
